function debounce(callback, wait, context = this) {
  let timeout = null; 
  let callbackArgs = null;

  const later = () => callback.apply(context, callbackArgs);

  return function() {
	callbackArgs = arguments;
	clearTimeout(timeout);
	timeout = setTimeout(later, wait);
  };
}

function normilizeString(str) {
  return (typeof str === 'string') ? str.trim().toLowerCase() : false;
}

function urlParam(name) {
  let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	return results ? results[1] || 0 : false;
}

function declOfNum(number, titles) {  
    let cases = [2, 0, 1, 1, 1, 2];  
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
}

function dadataJoin(arr /*, separator */) {
  var separator = arguments.length > 1 ? arguments[1] : ", ";
  return arr.filter(function(n){return n}).join(separator);
}

function isTouch() {
  return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

function scrollTo(el, timeout = 1000) {
  console.log(el)
  $([document.documentElement, document.body]).animate({
    scrollTop: $(el).offset().top
  }, timeout);
}

function fireNativeEvent(element, event){
  if (document.createEventObject){
      // dispatch for IE
      var evt = document.createEventObject();
      return element.fireEvent('on'+event,evt)
  }
  else{
      // dispatch for firefox + others
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true ); // event type,bubbling,cancelable
      return !element.dispatchEvent(evt);
  }
}


export default {debounce, normilizeString, urlParam, declOfNum, dadataJoin, isTouch, scrollTo, fireNativeEvent}
